import React from 'react'

import { HandCoinIcon } from '~/assets/icons'
import { useInBucket } from '~/hooks/use-in-bucket'

import styles from './styles.module.css'

export const PriceRiseHeroLine: React.FC = () => {
  const showPriceRiseHeroLine = useInBucket('experiment-mid-contract-price-rise-details-badge', 'variant')
  if (!showPriceRiseHeroLine) return null

  return (
    <div className={styles.wrapper}>
      Look for
      <span className={styles.badge}>
        <HandCoinIcon className={styles.icon} />

        <span>No price rise</span>
      </span>
      in your results
    </div>
  )
}
